<template lang="pug">
  .user_container.page_container(v-if="userRole == 1")
    .page_header
      .page_header_column
        b-field
          b-input(
            placeholder="キーワードで検索"
            type="search"
            icon="search"
            rounded
            size="is-medium"
            @input="getUserList")
      .page_header_column
        b-button(
          type="is-info"
          size="is-medium"
          outlined
          icon-left="plus"
          @click="openUserModal('add')") ユーザーの追加
    .userList(v-if="userList" v-cloak)
      b-table(
        :data="userList"
        ref="table"
        :bordered="table.isBordered"
        :striped="table.isStriped"
        :narrowed="table.isNarrowed"
        :loading="table.isLoading"
        :mobile-cards="table.hasMobileCards"
        :default-sort-direction="table.defaultSortDirection"
        :sort-icon="table.sortIcon"
        :sort-icon-size="table.sortIconSize"
        hoverable
        class="userList_table")
        b-table-column(v-slot="props" field="name" label="ユーザー名" width="100" sortable)
          span._name {{ props.row.name }}
        b-table-column(v-slot="props" field="mail" label="Googleアカウント" width="170" sortable)
          span._value(v-if="props.row.mail") {{ props.row.mail }}
        b-table-column(v-slot="props" field="role" label="権限" width="110" centered sortable)
          template
            b-tag._publish(
              :type="props.row.role == 1 ? 'is-info is-light' : 'is-light'"
              size="is-large") {{ props.row.role == 1 ? '管理者' : '一般ユーザー' }}
        b-table-column(v-slot="props" field="edit" label="編集" width="60" centered)
          button.ui-icon-button(@click="openUserModal( 'edit', props.row )")
            b-icon.is-opacity(icon="edit")
        b-table-column(v-slot="props" field="delete" label="削除" width="60" centered)
          button.ui-icon-button(@click="deleteConfirm(props.row)")
            b-icon.is-danger(icon="trash-alt")
        template(v-slot:empty v-if="!isInitialLoading")
          p._empty_message 該当するユーザーはいません
    // 追加・編集モーダル
    b-modal.userModal(v-model="isModalActive" :width="640")
      user-modal(
        :is-modal-active="isModalActive"
        :modal-type="modalType"
        :user-data="selectedUserData"
        @setNewData="getUserList"
        @closeModal="closeUserModal()")
  .user_container.page_container(v-else-if="userRole == 0")
    b-message._locked(has-icon icon="padlock") このページへのアクセスには、管理者権限が必要です
</template>

<script>
import UserModal from '@/components/UserModal.vue'

export default {
  name: 'User',
  head: {
    title() {
      return {
        inner: 'ユーザー',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  components: {
    UserModal
  },
  data: function(){
    return {
      userList: [],
      isInitialLoading: true,

      /* 追加フォーム */
      selectedUserData: null,
      isModalActive: false,
      modalType: null,

      /* 絞り込みフォーム */
      searchForm: {
        key: null,
      },

      /* b-table settings */
      table: {
        isEmpty: false,
        isBordered: false,
        isStriped: false,
        isNarrowed: false,
        isLoading: false,
        hasMobileCards: true,
        defaultSortDirection: 'asc',
        sortIcon: 'arrow-up',
        sortIconSize: 'is-small',
        isPaginated: false,
      },

      userRole: 0
    }
  },
  created() {
    this.userRole = this.$cookies.get('role')

    this.getUserList()
  },
  methods: {
    openUserModal(type, data){
      if( type === 'edit' ) {
        this.selectedUserData = data
      }

      this.modalType = type
      this.isModalActive = true
    },
    closeUserModal(){
      this.isModalActive = false
    },
    deleteConfirm(user){
      let message
      if( user.mail === this.$cookies.get('user_mail') ) {
        message = 'あなたがログインしているアカウントです。<br>削除すると、管理画面にログインできなくなりますのでご注意ください。'
      } else {
        message = '削除されたユーザーは、管理画面にログインできなくなります。'
      }
      this.$buefy.dialog.confirm({
        title: user.name + ' を削除しますか？',
        message: message,
        confirmText: 'ユーザーを削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.deleteUser(user)
        }
      })
    },
    async getUserList(val) {
      try {
        this.table.isLoading = true

        const data_obj = {
          sort: 2,
          keyword: val
        }

        const res = await this.$axios.get(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.USERS,
            { params: data_obj }
        )

        const r = res.data

        if( r.status == 1 ){
          const data = r.data
          this.userList = data
        } else {
          if( r.errors[0].status == 403 ) {
            this.$store.dispatch('promptToLogin')
            return
          } else if( r.errors[0].status == 500 ) {
            this.$cookies.set('role', 0)
            this.userRole = 0
          } else {
            this.$common.createErrorMessage(r.errors[0], 'ユーザー一覧の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.table.isLoading = false
        this.isInitialLoading = false
      }
    },
    async deleteUser(user) {
      try {
        const res = await this.$axios.delete(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.USERS_.replace(':id', user.id)
          )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('ユーザー '+ user.name + ' を削除しました')
          this.getUserList()
        }else{
          if( r.errors[0].status == 403 ) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors[0], 'ユーザーの削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>